import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.payoutByLink';
export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['title', 'Create Payout'],
    CONTROL_LABEL: ['controlLabel', 'Create Payout'],
    ORDER_CREATION_ERROR: ['payoutCreationError', 'Unable to create payout'],
    MERCHANT_SELECTION: ['merchantSelection', 'Select Merchant'],
    MERCHANT_SELECT_PLACEHOLDER: ['merchantSelectionPlaceholder', 'Select Merchant'],
    MERCHANT_SELECT_LABEL: ['merchantSelectLabel', 'Merchant'],
    CONFIRMATION_MODAL: {
      TITLE: ['confirmationModal.title', 'Confirm Payout'],
      REFUND_AMOUNT: ['confirmationModal.refundAmount', 'Tax Refund Amount'],
      TO: ['confirmationModal.to', 'to'],
      CANCEL: ['confirmationModal.cancel', 'Cancel'],
      CONFIRM: ['confirmationModal.confirm', 'Confirm'],
    },
  },
  NAMESPACE,
);

export const BREADCRUMBS = [
  ['payoutByLink', 'Create Payout'],
  ['createPayout', 'Customer Payout'],
];

export default LABELS;
